module.exports = __webpack_public_path__ + "static/img/logo-ucm-header.6cb91da.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-ucm-header.png
// module id = q2vb
// module chunks = 1